import React from "react";
import {
  Container,
  Content,
  HeadingContainer,
  Heading,
  Text,
  Details,
  Detail,
  Traits,
  Trait,
  PhotoContainer,
  Photo,
} from "./About.Styled";
import { motion } from "framer-motion";
import { commonUpAppearVariants } from "../../animations/motion";
import portraitSmall from "../../assets/viet-hoang-nguyen-320.webp";
import portraitLarge from "../../assets/viet-hoang-nguyen-640.webp";

const About = () => {
  return (
    <Container
      id="About"
      as={motion.section}
      variants={commonUpAppearVariants}
      initial="closed"
      whileInView="open"
      viewport={{ once: true, amount: 0.15 }}
    >
      <Content>
        <HeadingContainer>
          01. <Heading>About</Heading>
        </HeadingContainer>
        <Text>
          I’m a Prague-based independent front-end engineer. Since 2021, I’ve
          delivered customer-facing web and mobile products for fintech, AI,
          Web3, and hospitality teams, both directly and through agencies. My
          core stack includes React, React Native, Next.js, Vue, Nuxt, and
          TypeScript.
        </Text>
        <Text>
          I turn product goals into clear, robust interfaces and flag UX edge
          cases before they reach production. I work closely with designers,
          backend engineers, and stakeholders to keep delivery practical and
          product intent intact.
        </Text>
        <Details aria-label="Location and availability">
          <Detail>Prague, Czechia</Detail>
          <Detail>Remote collaboration worldwide</Detail>
        </Details>
        <Traits aria-label="Experience focus">
          <Trait>Web &amp; mobile</Trait>
          <Trait>Product delivery</Trait>
          <Trait>Cross-functional</Trait>
          <Trait>Distributed teams</Trait>
        </Traits>
      </Content>
      <PhotoContainer>
        <Photo
          src={portraitLarge}
          srcSet={`${portraitSmall} 320w, ${portraitLarge} 640w`}
          sizes="(max-width: 499px) calc(100vw - 60px), (max-width: 563px) 440px, (max-width: 1023px) 360px, 400px"
          alt="Viet Hoang Nguyen"
          width="640"
          height="853"
          loading="lazy"
          decoding="async"
        />
      </PhotoContainer>
    </Container>
  );
};

export default About;
